import React from 'react';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { useTranslation } from '@common/hooks/useTranslation';
import { Box } from '@components/Box';
import { Field } from '@components/FormElements';
import { RichTextInput } from '@components/FormElements/RichTextInput';
import { Stack } from '@components/Stack';
import { JobDescriptionCalloutDetails } from './components/JobDescriptionCalloutDetails';

type JobDescriptionProps = {
  value: string;
  onChange: () => void;
  onBlur: () => void;
  error?: string;
  placeholder?: string;
};

export const JobDescriptionField = ({
  error,
  onChange,
  onBlur,
  value,
  placeholder
}: JobDescriptionProps) => {
  const { t } = useTranslation();

  function charCountProvider(count: number): string {
    return t('postJobForm.jobDescription.characters', { count });
  }

  return (
    <Stack spacing="small">
      <Field
        label={t('postJobForm.fieldLabel.optionalJobDescription')}
        message={
          error && (
            <Box marginTop="xxsmall">
              <ErrorMessage>{error}</ErrorMessage>
            </Box>
          )
        }
      >
        <Box>
          <RichTextInput
            error={Boolean(error)}
            value={value}
            placeholder={placeholder}
            charCountProvider={charCountProvider}
            onChange={onChange}
            onBlur={onBlur}
            showCharCount={false}
          />
        </Box>
      </Field>

      <JobDescriptionCalloutDetails />
    </Stack>
  );
};
